import { dataCompany } from "../legal/TermsPage"
import { Home } from "../../components/backgrounds/Home"

export function FisicoPage() {
    return (
        <div className="relative bg-purpleLight overflow-hidden">
            <Home title={'Solicitud en físico'} />
            <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
                <div className="relative h-full text-lg max-w-prose mx-auto" aria-hidden="true">
                </div>
            </div>
            <div className="relative px-4 py-20 sm:px-6 lg:px-8">
                <div className="text-lg prose prose-purple text-tdark max-w-prose mx-auto">
                    <h1>
                        <span className="mt-2 block text-3xl text-center font-bold text-tdark sm:text-4xl">
                            Solicita tu crédito a través del canal físico (Opcional)
                        </span>
                    </h1>
                    {dataCompany.map((item) => (
                        <div className="mt-8 text-xl">
                            <span>
                                GRUPO EMPRESARIAL ANAV S.A.S. – Galilea, ha dispuesto para el titular que
                                no desee instrumentar la firma electrónica y demás beneficios descritos en
                                el pago de la cuota de administración a través de la
                                plataforma web <a href='/'>galilea.co</a>, un canal adicional
                                para realizar la solicitud del crédito mediante el envío de la siguiente
                                información a la dirección de correspondencia física {item.address}.
                            </span>
                        </div>
                    ))}
                </div>
                <div className="mt-6 prose prose-purple prose-xl text-tdark mx-auto">
                    <ul role="list" className='marker:text-purple list-disc'>
                        <li className='my-0 ml-6'>Fotocopia cédula de ciudadanía.</li>
                        <li className='my-0 ml-6'>Certificado laboral no mayor a 30 días.</li>
                        <li className='my-0 ml-6'>Últimos 2 desprendibles de pago de nómina.</li>
                        <li className='my-0 ml-6'>Certificado de cuenta bancaria no mayor a 30 días.</li>
                        <li className='my-0 ml-6'>Extracto bancario de los últimos 3 meses.</li>
                        <li className='my-0 ml-6'>Contrato debidamente firmado y autenticados ante Notaría.</li>
                        <li className='my-0 ml-6'>Pagaré y carta de instrucciones debidamente firmado y autenticados ante Notaría.</li>
                        <li className='my-0 ml-6'>Documento de aceptación de los términos y condiciones generales del servicio debidamente firmado y autenticado ante Notaría.</li>
                        <li className='my-0 ml-6'>Documento de aceptación de la Política de Privacidad y Tratamiento de datos debidamente firmado y autenticado ante Notaría.</li>
                    </ul>
                    <div className="text-lg pt-6 max-w-prose mx-auto">
                        <div className="mt-8 text-xl">
                            <span>
                                El titular se obliga a suministrar información veraz, completa, 
                                actualizada y comprobable, así mismo, este deberá garantizar que a 
                                partir de los datos suministrados no busca inducir al error en los 
                                procesos internos para lo cual Galilea en procura de la veracidad 
                                realizará las rectificaciones respectivas siendo estas últimas de 
                                pleno conocimiento del usuario. No obstante, Galilea se reserva el 
                                derecho de aprobación de la solicitud de crédito y los tiempos para 
                                su respuesta.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
